import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {AuthInterceptadorService} from "./auth-interceptador.service";
import {LoadingInterceptorService} from "./loading-interceptor.service";

export const httpInterceptorProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptadorService,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: LoadingInterceptorService,
    multi: true
  }
];
